module.exports = __webpack_public_path__ + "static/media/id-card.cf439b6f.svg";